import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromSearchResults from '../reducers/search-results.reducer';

export const getSearchResultState = createSelector(fromFeature.getSearchState, (state: fromFeature.LandingState) => state.results);
export const getSearchResultEntities = createSelector(getSearchResultState, fromSearchResults.getSearchResultsEntities);
export const getSearchResultsLoaded = createSelector(getSearchResultState, fromSearchResults.getSearchResultsLoaded);
export const getSearchResultsLoading = createSelector(getSearchResultState, fromSearchResults.getSearchResultsLoading);
